// @flow

import memoize from 'memoize-weak';

import toLegacyCompatibleService from '@zapier/services/src/utils/toLegacyCompatibleService';

import type { Service } from '@zapier/services/src/types';

const combineToLegacyCompatibleServices = memoize(
  (
    publicServices: Array<Service>,
    privateServices: Array<Service>,
    includePrivateServices: boolean
  ) => {
    const consumerServices = includePrivateServices
      ? publicServices.concat(privateServices)
      : publicServices;

    const legacyCompatibleServices = consumerServices.map(
      toLegacyCompatibleService
    );
    return legacyCompatibleServices;
  }
);

export default combineToLegacyCompatibleServices;
